module.exports = __webpack_public_path__ + "06baf70981faa9c96bc347fbbe05f735.png";